import { MegamenuItem, NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";
import __megamenu from "./jsons/__megamenu.json";
import { useLanguage } from '../contexts/languageContext'


const megaMenuDemo: MegamenuItem[] = [
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Company",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.Company,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "App Name",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.AppName,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/5059013/pexels-photo-5059013.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "City",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.City,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/5159141/pexels-photo-5159141.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Contruction",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.Contruction,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://images.pexels.com/photos/7473041/pexels-photo-7473041.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    title: "Country",
    items: __megamenu.map((i) => ({
      id: ncNanoId(),
      href: "/unique_id_",
      name: i.Country,
    })),
  },
];

const demoChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
  },
  {
    id: ncNanoId(),
    href: "/home-2",
    name: "Real Estate",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/home",
    name: "Home",
    isNew: true,
  },
];

const aboutChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/about",
    name: "Mission & People",
  },
];

const productChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/blog-swing-tech",
    name: "Swing Tech",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-edu",
    name: "Education",
  },
  {
    id: ncNanoId(),
    href: "/blog-space-themed-park",
    name: "Space Themed Park",
    isNew: true,
  },
];

const productSimulatorChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/blog-swing-tech",
    name: "Swing X",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-usecases",
    name: "Usecases",
  },
];

const productEducationChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/blog-edu",
    name: "Overview",
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-regular-class",
    name: "Aerospace 101",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-can-satellites",
    name: "Can Satellite",
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-satellites",
    name: "Satellite 101",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-satellite-operation",
    name: "Satellite Ground Control System",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-satellite-image-processing",
    name: "Satellite Image Processing",
    isNew: true,
  },
];

//const productThemedParkChildMenus: NavItemType[] = [
//  {
//    id: ncNanoId(),
//    href: "/blog-space-themed-park",
//    name: "Overview",
//   isNew: true,
// },
//];


const mediaChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/media",
    name: "News",
  }
];


const contactusChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Location",
  },
];

const aboutChildMenus_KR: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/about",
    name: "미션",
  },
];

const productChildMenus_KR: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/blog-swing-tech",
    name: "스윙모션 테크/ Swing X",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-edu",
    name: "교육",
  },
  {
    id: ncNanoId(),
    href: "/blog-space-themed-park",
    name: "우주테마파크",
    isNew: true,
  },
];




const productSimulatorChildMenus_KR: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/blog-swing-tech",
    name: "스윙모션 테크/ Swing X",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-usecases",
    name: "활용 사례",
  },
];

const productEducationChildMenus_KR: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/blog-edu",
    name: "개요",
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-regular-class",
    name: "일반",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-can-satellites",
    name: "캔 위성",
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-satellites",
    name: "위성 교육",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-satellite-operation",
    name: "위성 관제 운영",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/blog-edu-satellite-image-processing",
    name: "위성 활용",
    isNew: true,
  },
];

//const productThemedParkChildMenus_KR: NavItemType[] = [
//  {
//    id: ncNanoId(),
//    href: "/blog-space-themed-park",
//    name: "개요",
//    isNew: true,
//  },
  
//];

const mediaChildMenus_KR: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/media",
    name: "뉴스/기사",
  }
];


const contactusChildMenus_KR: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/contact",
    name: "위치",
  },
];

const aboutMenu: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Vision",
  }
];

const missionMenu: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Mission Statement",
  }
];

const contactMenu: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Details",
  }
];

const mediaMenu: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "News",
  }
];

const productMenu: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Simulator Platform",
  },
  {
    id: ncNanoId(),
    href: "/",
    name: "Simulator Platform",
  }
];

const otherPageChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/add-listing-1",
    name: "+ Add Listings",
  },
  {
    id: ncNanoId(),
    href: "/media",
    name: "Blog Page",
  },
  {
    id: ncNanoId(),
    href: "/blog-edu",
    name: "Blog Single",
  },
  {
    id: ncNanoId(),
    href: "/about",
    name: "About",
  },
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Contact us",
  },
  {
    id: ncNanoId(),
    href: "/login",
    name: "Login",
  },
  // {
  //   id: ncNanoId(),
  //   href: "/signup",
  //   name: "Signup",
  // },
  {
    id: ncNanoId(),
    href: "/subscription",
    name: "Subscription",
  },
];

const templatesChildrenMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/add-listing-1",
    name: "+ Add Listings",
    type: "dropdown",
    children: [
      {
        id: ncNanoId(),
        href: "/add-listing-1",
        name: "Add Listings 1",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-2",
        name: "Add Listings 2",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-3",
        name: "Add Listings 3",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-4",
        name: "Add Listings 4",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-5",
        name: "Add Listings 5",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-6",
        name: "Add Listings 6",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-7",
        name: "Add Listings 7",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-8",
        name: "Add Listings 8",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-9",
        name: "Add Listings 9",
      },
      {
        id: ncNanoId(),
        href: "/add-listing-10",
        name: "Add Listings 10",
      },
    ],
  },
  //
  { id: ncNanoId(), href: "/checkout", name: "Checkout" },
  { id: ncNanoId(), href: "/pay-done", name: "Pay done" },
  //
  { id: ncNanoId(), href: "/author", name: "Author Page" },
  { id: ncNanoId(), href: "/account", name: "Account Page" },
];

export const NAVIGATION_DEMO_KR: NavItemType[] = [
{
  id: ncNanoId(),
  href: "/",
  name: "스윙 X",
  type: "dropdown",
  children: productSimulatorChildMenus_KR,
  isNew: true,
},
{
  id: ncNanoId(),
  href: "/",
  name: "교육",
  type: "dropdown",
  children: productEducationChildMenus_KR,
  isNew: true,
},
//{
  //id: ncNanoId(),
  //href: "/",
  //name: "코스모게이트",
  //type: "dropdown",
  //children: productThemedParkChildMenus_KR,
  //isNew: true,
//},
{
  id: ncNanoId(),
  href: "/",
  name: "미디아",
  type: "dropdown",
  children: mediaChildMenus_KR,
  isNew: true,
},
  {
  id: ncNanoId(),
  href: "/",
  name: "소개",
  type: "dropdown",
  children: aboutChildMenus_KR,
  isNew: true,
},
{
  id: ncNanoId(),
  href: "/",
  name: "오시는길",
  type: "dropdown",
  children: contactusChildMenus_KR,
  isNew: true,
},];

export const NAVIGATION_DEMO_EN: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Swing X",
    type: "dropdown",
    children: productSimulatorChildMenus,
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/",
    name: "Education",
    type: "dropdown",
    children: productEducationChildMenus,
    isNew: true,
  },
  //{
  //  id: ncNanoId(),
  //  href: "/",
  //  name: "Cosmogate",
  //  type: "dropdown",
  //  children: productThemedParkChildMenus,
  //  isNew: true,
  //},
  {
    id: ncNanoId(),
    href: "/",
    name: "Media",
    type: "dropdown",
    children: mediaChildMenus,
    isNew: true,
  },
      {
    id: ncNanoId(),
    href: "/",
    name: "About",
    type: "dropdown",
    children: aboutChildMenus,
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/",
    name: "Contact Us",
    type: "dropdown",
    children: contactusChildMenus,
    isNew: true,
  },
  // {
  //   id: ncNanoId(),
  //   href: "/",
  //   name: "Home",
  //   type: "dropdown",
  //   children: demoChildMenus,
  //   isNew: true,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/unique_id_",
  //   name: "Five columns",
  //   type: "megaMenu",
  //   megaMenu: megaMenuDemo,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/listing-stay",
  //   name: "Listing Page",
  //   type: "dropdown",
  //   isNew: true,
  //   children: [
  //     {
  //       id: ncNanoId(),
  //       href: "/listing-stay",
  //       name: "Stay listing",
  //       type: "dropdown",
  //       children: [
  //         { id: ncNanoId(), href: "/listing-stay", name: "Stay page" },
  //         {
  //           id: ncNanoId(),
  //           href: "/listing-stay-map",
  //           name: "Stay page (map)",
  //         },
  //         { id: ncNanoId(), href: "/listing-stay-detail", name: "Stay Detail" },
  //       ],
  //     },

  //     //
  //     {
  //       id: ncNanoId(),
  //       href: "/listing-experiences",
  //       name: "Experiences listing",
  //       type: "dropdown",
  //       children: [
  //         {
  //           id: ncNanoId(),
  //           href: "/listing-experiences",
  //           name: "Experiences page",
  //         },
  //         {
  //           id: ncNanoId(),
  //           href: "/listing-experiences-map",
  //           name: "Experiences page (map)",
  //         },
  //         {
  //           id: ncNanoId(),
  //           href: "/listing-experiences-detail",
  //           name: "Experiences Detail",
  //         },
  //       ],
  //     },

  //     //
  //     {
  //       id: ncNanoId(),
  //       href: "/listing-car",
  //       name: "Cars listing",
  //       type: "dropdown",
  //       children: [
  //         { id: ncNanoId(), href: "/listing-car", name: "Cars page" },
  //         { id: ncNanoId(), href: "/listing-car-map", name: "Cars page (map)" },
  //         { id: ncNanoId(), href: "/listing-car-detail", name: "Car Detail" },
  //       ],
  //     },

  //     //
  //     {
  //       id: ncNanoId(),
  //       href: "/listing-real-estate",
  //       name: "Real Estate Listings",
  //       isNew: true,
  //       type: "dropdown",
  //       children: [
  //         {
  //           id: ncNanoId(),
  //           href: "/listing-real-estate",
  //           name: "Real Estate Listings",
  //           isNew: true,
  //         },
  //         {
  //           id: ncNanoId(),
  //           href: "/listing-real-estate-map",
  //           name: "Real Estate Maps",
  //           isNew: true,
  //         },
  //       ],
  //     },
  //     //
  //     {
  //       id: ncNanoId(),
  //       href: "/listing-flights",
  //       name: "Flights listing",
  //       isNew: true,
  //     },
  //   ],
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/author",
  //   name: "Templates",
  //   type: "dropdown",
  //   children: templatesChildrenMenus,
  // },

  // {
  //   id: ncNanoId(),
  //   href: "/blog",
  //   name: "Other pages",
  //   type: "dropdown",
  //   children: otherPageChildMenus,
  // },
];
